module.exports = __webpack_public_path__ + "media/images/athletes/3428-ab17576c1fa892715e253530f5647309.png";